module.exports = __webpack_public_path__ + "static/img/中心定位.d0e007f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/中心定位.png
// module id = tjNO
// module chunks = 1